import {
  createStyles,
  MANTINE_SIZES,
  MantineNumberSize,
  rem,
} from '@mantine/core'

const useHeaderFooterStyles = createStyles(
  (
    theme,
    { tableFontSize }: { tableFontSize: MantineNumberSize } = {
      tableFontSize: 'sm',
    },
  ) => {
    const headerFontSize =
      typeof tableFontSize === 'number'
        ? tableFontSize
        : MANTINE_SIZES.includes(
            tableFontSize as 'xs' | 'sm' | 'md' | 'lg' | 'xl',
          )
        ? theme.fontSizes[tableFontSize]
        : tableFontSize

    const headerFooterBorder = `${rem(1)} solid ${
      theme.colorScheme === 'dark' ? theme.colors.dark[3] : theme.colors.gray[2]
    }`

    const headerFooterBackgroundColor =
      theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white

    const headerFooterTransition = 'box-shadow 150ms ease'
    return {
      th: {
        padding: '0 !important',
      },

      hoverControl: {
        cursor: 'pointer !important',
        '&:hover': {
          backgroundColor:
            theme.colorScheme === 'dark'
              ? theme.colors.dark[6]
              : theme.colors.gray[0],
        },
      },
      headerPadding: {
        padding: `${theme.spacing.xs} ${theme.spacing.md}`,
      },
      control: {
        cursor: 'default !important',
        width: '100%',
      },

      inactiveSortIcon: {
        color:
          theme.colorScheme === 'dark'
            ? theme.colors.dark[2]
            : theme.colors.gray[6],
      },

      sortIcon: {
        width: headerFontSize,
        height: headerFontSize,
        borderRadius: headerFontSize,
        fontSize: headerFontSize,
      },

      header: {
        zIndex: 2,
        position: 'sticky',
        top: 0,
        backgroundColor: headerFooterBackgroundColor,
        transition: headerFooterTransition,

        '&::after': {
          content: '""',
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          borderBottom: headerFooterBorder,
        },
      },

      footer: {
        zIndex: 2,
        position: 'sticky',
        bottom: -1,
        backgroundColor: headerFooterBackgroundColor,
        transition: headerFooterTransition,

        '&::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          right: 0,
          top: 0,
          borderTop: headerFooterBorder,
        },
      },

      scrolled: {
        boxShadow: theme.shadows.sm,
      },
      scrolledInvert: {
        boxShadow:
          '0 -0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 -0.625rem 0.9375rem -0.3125rem, rgba(0, 0, 0, 0.04) 0 -0.4375rem 0.4375rem -0.3125rem',
      },
    }
  },
)

export default useHeaderFooterStyles
